var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSortable)?_c('v-sheet',{staticClass:"d-flex align-center cursor-pointer",attrs:{"color":"transparent"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.head.text)+" "),_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1):_c('span',[_vm._v(_vm._s(_vm.head.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }